module.exports = __webpack_public_path__ + "img/logo-light.35a49ec3.png";